"use client";

import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

/* The server holds a Sign-In-With-Solana proof now: every tab's Glyph link
   asks again then, never on a timer. */
const NAME = "mudwater:solana-proof";

export function announceProof() {
  if (typeof BroadcastChannel === "undefined") return;
  const channel = new BroadcastChannel(NAME);
  channel.postMessage(null);
  channel.close();
}

/** Refetches the queries under `key` once a proof lands, in any tab. */
export function useRefetchOnProof(key: string) {
  const client = useQueryClient();
  useEffect(() => {
    if (typeof BroadcastChannel === "undefined") return;
    const channel = new BroadcastChannel(NAME);
    channel.onmessage = () =>
      void client.invalidateQueries({ queryKey: [key] });
    return () => channel.close();
  }, [client, key]);
}
